<style lang="scss" scoped>
.noticitaions {
    position: absolute;
    width: 350px;
    right: -100px;
    top: 70px;
    height: 300px;
    overflow: auto;
    .notification {
        cursor: pointer;
        transition: background 0.3s;
        padding: 20px;
        .icon {
            flex: none;
            width: 20px;
            height: 20px;
            path {
                fill: #f2644a;
            }
        }
        &:not(:last-child) {
            border-bottom: 1px solid #e3eaee;
        }
        &:hover {
            background: #fafafa;
        }
    }
}
</style>

<template>
    <div v-if="show" class="noticitaions" v-click-outside="close">
        <box :padding="0" v-for="(n, key) in orderedNotifications" :clickable="true" @click="goToDetail(n)" :key="key" :border-radius="0">
            <template slot="content">
                <div class="notification d-flex">
                    <!-- icon -->
                    <component class="my-auto mr-15 icon" :is="'i-' + getIconType(n.type)"></component>
                    <div>
                        <p class="mb-0 fs-14 fw-nrmal text-secondary">{{ getMessage(n.json_message) }}</p>
                        <p class="mb-0 fs-12 fw-normal">{{ $moment.unix(parseInt(n.created_at)).fromNow() }}</p>
                    </div>
                </div>
            </template>
        </box>
    </div>
</template>

<script>
import { firebaseApp } from "../../firebase";
import { mapGetters, mapActions } from "vuex";
import { orderBy } from "lodash";

let db = firebaseApp.database();
export default {
    props: {
        /**
         * Boolean defining if the notifications will be shown
         * @type {Boolean}
         */
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // notifications: [{ type: 'chat', title: 'Chat notification', created_at: '5 hours ago' }, { type: 'chat', title: 'Chat notification', created_at: '5 hours ago' }, { type: 'chat', title: 'Chat notification', created_at: '5 hours ago' }]
            firebaseToken: null,
            myFirebaseRef: "",
            notifications: [],
            init: false
        };
    },
    mounted() {
        this.myFirebaseRef = db
            .ref(
                process.env.VUE_APP_CODE_ENV +
                    "/pushes/" +
                    this.user.firebase_uid
            )
            .limitToLast(5);
        this.retrieveFirebaseToken();
    },

    watch: {
        firebaseToken: function(firebaseToken) {
            let vm = this;
            let language = vm.language;
            firebaseApp
                .auth()
                .signInWithCustomToken(firebaseToken)
                .then(
                    function() {
                        vm.myFirebaseRef.on(
                            "value",
                            function(snapshot) {
                                let newPushes =
                                    snapshot.val() === null
                                        ? []
                                        : Object.values(snapshot.val());
                                if (vm.init && newPushes.length) {
                                    let newPush =
                                        newPushes[newPushes.length - 1];
                                    let type = newPush.type.split(".");
                                
                                    vm.$toasted.show(newPush.json_message[language]);

                                    if (type[0] === "shipment") {                                    
                                        if (type[1] === 'offer' && type[2] === 'accepted') {
                                            vm.getMyShipments();
                                            vm.getOffers();
                                        } else if (type[1] === 'new') {
                                            vm.searchShipments();
                                        } else if (type[1] === 'message') {
                                            vm.getConversations();
                                        } else {
                                            vm.getMyShipments();
                                        }    
                                    } else {
                                        vm.getAuthUser();
                                        vm.getFleet();
                                    }
                                }

                                vm.notifications = newPushes;
                                vm.init = true;
                            },
                            function(errorObject) {
                                console.log(
                                    "The read failed: " + errorObject.code
                                );
                            }
                        );
                    },
                    function(error) {
                        console.log(error);
                    }
                );
        }
    },

    methods: {
        ...mapActions([
            "searchShipments",
            "getMyShipments",
            "getOffers",
            "getAuthUser",
            "getConversations",
            "getFleet"
        ]),
        retrieveFirebaseToken() {
            let self = this;
            this.$http
                .post("/api/firebase_token")
                .then(function(response) {
                    self.firebaseToken = response.data;
                })
                .catch(error => {
                    console.error(error);
                });
        },

        close() {
            this.$emit("close");
        },

        getIconType(pushType) {
            let type = pushType.split(".");

            if (
                type[0] === "company" ||
                type[0] === "user" ||
                type[0] === "sender" ||
                type[0] === "driver"
            ) {
                return "profile";
            } else if (type[0] === "shipment") {
                if (type[1] === "message") {
                    return "chat";
                } else if (type[1] === "new") {
                    return "info";
                } else {
                    return "marker";
                }
            }
        },

        getRoute(pushType) {
            let type = pushType.split(".");

            if (type[0] === "company") {
            }
        },

        /* 
        | --------------
        | Navigate to the detail page
        | --------------
        */
        goToDetail(push) {
            let route = false;
            let type = push.type.split(".");

            if (type[0] === "company") {
                route = {
                    name: "profile-company"
                };
            } else if (
                type[0] === "user" ||
                type[0] === "sender" ||
                type[0] === "driver"
            ) {
                route = {
                    name: "profile-settings"
                };
            } else if (type[0] === "shipment") {
                if (type[1] === "message") {
                    route = {
                        name: "chat",
                        params: { shipmentId: push.shipment_id }
                    };
                } else if (type[1] === "new") {
                    route = {
                        name: "search"
                    };
                } else {
                    route = {
                        name: "shipment-detail",
                        params: { shipmentId: push.shipment_id }
                    };
                }
            }
            if (route) {
                this.$router.push(route);
            }
        },

        getMessage(item) {
            return item[this.language];
        },
    },

    computed: {
        ...mapGetters(["user", "language"]),
        orderedNotifications() {
            return orderBy(this.notifications, ["created_at"], ["desc"]);
        }
    }
};
</script>
